const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class CorporationServiceConnector {
  constructor(configuration) {
    this.httpClient = axios.create(configuration);
  }

  async createCorporation(options = {}) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/corporations`,
        method: 'POST',
        ...options,
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async updateCorporation(corporation) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/corporations/${corporation.id}`,
        method: 'PATCH',
        data: {
          name: corporation.name,
          communicationLanguage: corporation.communicationLanguage,
          contactEmail: corporation.contactEmail,
        },
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async deleteCorporation({ id }, options = {}) {
    try {
      const request = {
        url: `/${CURRENT_VERSION}/corporations/${id}`,
        method: 'DELETE',
        ...options,
      };

      const { data } = await this.httpClient(request);
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async listCorporations({ sort, page = 0, maxPerPage = 10, name }) {
    try {
      const params = { sort, page, maxPerPage };
      if (name) {
        params.name = name;
      }

      const { data, headers } = await this.httpClient.get(`/${CURRENT_VERSION}/corporations`, {
        params,
      });
      return { data, headers };
    } catch (error) {
      return this._handleError(error);
    }
  }

  _handleError(error) {
    throw errorMapper(error);
  }
}

module.exports = {
  CorporationServiceConnector,
};
